import { Pipe, PipeTransform } from '@angular/core';
import { QueueViewColumn } from '../../models/column.interface';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'appColumnNameFilter'
})
export class ColumnNameFilterPipe implements PipeTransform {
  constructor(private _translateService: TranslateService) {
  }

  transform(items: QueueViewColumn[], filterText: string): QueueViewColumn[] {
    if (filterText !== undefined && filterText !== '') {
      return items.filter(column => {
        return this._translateService.instant(column.displayName).toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) !== -1;
      });
    }
    return items;
  }
}
